import {Component, Inject, OnInit} from '@angular/core';
import {FileInputResult} from '../../components/file-input/file-input.component';
import {HttpLoaderService, SnackbarService} from '@tymes4-shared';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import {ConfirmService} from '../../../../../../../dist/tymes4-shared';
import {TranslateService} from '@ngx-translate/core'
import { ImageService, ImageTypeEnum } from '../../api';
@Component({
    selector: 'app-file-input-dialog',
    templateUrl: './file-input-dialog.component.html',
    styleUrls: ['./file-input-dialog.component.scss'],
    standalone: false
})
export class FileInputDialogComponent implements OnInit {

  private imageType: ImageTypeEnum;
  public fileInputResult: FileInputResult = null;
  public fileInputDescription: string;
  public isUploading: boolean;
  public title: string;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              private loader: HttpLoaderService,
              private snackbarService: SnackbarService,
              private imageService: ImageService,
              private confirmService: ConfirmService,
              private translate: TranslateService,
  public dialogRef: MatDialogRef<FileInputDialogComponent>) { }


  ngOnInit() {
    this.title = this.passedData.title;
    this.imageType = this.passedData.imageType ?? ImageTypeEnum.Default;
  }

  onFileSelect(fileInputResult: FileInputResult) {
    this.fileInputResult = fileInputResult;
  }

  onDescriptionChanged(e) {
    this.fileInputDescription = e.target.value;
  }

  uploadFile() {
    if (this.fileInputResult != null) {
      this.loader.open();
      this.isUploading = true;

      const file = this.fileInputResult.file;
      if (file.type.toLocaleLowerCase() === 'image/jpg' || file.type.toLocaleLowerCase() === 'image/jpeg' ||
        file.type.toLocaleLowerCase() === 'image/png' || file.type.toLocaleLowerCase() === 'image/bmp' || file.type.toLocaleLowerCase() === 'image/gif') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const mimeType = (reader.result as string).split(',')[0];
          const base64string = (reader.result as string).split(',')[1];

          this.imageService.uploadImage(null,  {
             Description: this.fileInputDescription,
             FileData: base64string,
             FileName: file.name,
             FileTypeName: file.type,
             MimeType: mimeType,
             ImageType: this.imageType
          })
            .subscribe(
              (imageId: number) => {
                this.isUploading = false;
                this.dialogRef.close(imageId);
                this.loader.close();
              },
              error => {
                this.isUploading = false;
                this.loader.close();
                const serverMsg = error.status === 400 && error.error?.Message;
                if (!serverMsg) {
                  throw error;
                }
                this.snackbarService.open(serverMsg, 'GENERIC.SNACKBAR.CLOSE', { panelClass: 'mat-error' });
              }
            );
        };
      }
      else {
        this.isUploading = false;
        this.loader.close();
        this.confirmService.confirm({
          title: this.translate.instant('IMAGE.FILE.UPLOAD.WRONG.FILE.WARNING.TITLE'),
          message: this.translate.instant(`IMAGE.FILE.UPLOAD.WRONG.FILE.WARNING.MESSAGE`)
        });
      }
    }
  }
}
